import { Container, Row, Col } from "react-bootstrap";
import MainRules from "components/MainRules";

const Rules = () => {
  return (
	<Container>
		<Row>
			<Col>
				<MainRules/>
			</Col>
		</Row>
	</Container>
  )
}

export default Rules